import axiosInstance from "../../utils/axios";

export const getJobs = async (filter) => {
  const response = await axiosInstance.get("/jobs");

  if (filter === "All") {
    return response.data;
  } else {
    return response.data.filter((item) => item.type === filter);
  }
};

export const getJobById = async (id) => {
  const response = await axiosInstance.get(`/jobs/${id}`);
  return response.data;
};

export const editJob = async (job) => {
  const response = await axiosInstance.patch(`/jobs/${job.id}`, job);
  return response.data;
};

export const addNewJob = async (job) => {
  const response = await axiosInstance.post("/jobs", job);
  return response.data;
};

export const removeJob = async (id) => {
  const response = await axiosInstance.delete(`/jobs/${id}`);
  return response.data;
};
